import { useEffect, useRef } from 'react';

export function useClickOutside<T extends HTMLElement>(handler: () => void, isActive: boolean) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (!isActive) {
      return undefined;
    }

    function listener(event: MouseEvent | TouchEvent) {
      if (!ref.current || ref.current.contains(event.target as Node)) {
        return;
      }
      handler();
    }

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [handler, isActive]);

  return ref;
}
